module.exports = __webpack_public_path__ + "static/media/search.c34eea06.svg";